module.exports = {
  user: {
    path: '//user',
    post: true
  }
};
